"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusOAuthLogin = void 0;
const react_oauth_1 = require("@yanzi/react-oauth");
const react_1 = require("react");
const useCirrusLoginCredentials_1 = require("./useCirrusLoginCredentials");
function useCirrusOAuthLogin() {
    const { accessToken, isIntercepting, error } = react_oauth_1.useOAuth();
    const res = useCirrusLoginCredentials_1.useCirrusLoginCredentials(accessToken ? () => __awaiter(this, void 0, void 0, function* () { return ({ accessToken: `jwt:${yield accessToken.get()}` }); }) : null);
    return react_1.useMemo(() => (Object.assign(Object.assign({}, res), { isLoading: res.isLoading || isIntercepting, isIntercepting, error: error !== null && error !== void 0 ? error : res.error })), [error, isIntercepting, res]);
}
exports.useCirrusOAuthLogin = useCirrusOAuthLogin;
//# sourceMappingURL=useCirrusOAuthLogin.js.map